
import ReviewScore from '@/enums/ReviewScore';

const PERFECT_SCORE = 5;

export default {
  name: 'AppRate',
  props: {
    score: { type: Number, required: true },
    size: { type: Number, default: 18 },
    withText: { type: Boolean, default: false },
    starColor: { type: String, default: null },
    emptyStarColor: { type: String, default: null }
  },
  computed: {
    scoreLabel() {
      return ReviewScore.t(this.score);
    },
    hasPartialStar() {
      return this.score % 1 !== 0;
    },
    filledStarsCount() {
      return Math.floor(this.score);
    },
    emptyStarsCount() {
      const starsCount = Math.ceil(this.score);

      return PERFECT_SCORE - starsCount;
    },
    filledPercent() {
      const decimalPart = this.score % 1;
      return (decimalPart * 100).toFixed(0);
    },
    maskGradient() {
      const emptyPercent = 100 - this.filledPercent;
      return this.filledPercent < emptyPercent
        ? `linear-gradient(to left, transparent ${emptyPercent}%, ${this.starColor} ${this.filledPercent}%)`
        : `linear-gradient(to right, ${this.starColor} ${this.filledPercent}%, transparent ${emptyPercent}%)`;
    },
    rateStyle() {
      return {
        '--size': `${this.size}px`,
        '--star-color': this.starColor,
        '--mask-gradient': this.maskGradient,
        '--empty-star-color': this.emptyStarColor
      };
    }
  }
};
